// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__1KUBi","addWidgetButton":"Header_addWidgetButton__23Klj","dashboardTabs":"Header_dashboardTabs__1_mv0","active":"Header_active__3M6kw"};